export const scriptLoader = (src, id) => {
  return new Promise((resolve, reject) => {
    ((document, elementName, id) => {
      if (document.getElementById(id)) {return;}
      const js = document.createElement(elementName);
      js.id = id;
      js.type = 'text/javascript';
      js.src = src;
      js.async = true;
      js.onload = () => resolve(src);
      js.onerror = (err) => reject(JSON.stringify(err));
      if (document.head) {document.head.appendChild(js);}
    })(document, 'script', id);
  });
};
